export const ADD_CONTACT_MODAL_CLOSE = 'ADD_CONTACT_MODAL_CLOSE'
export const ATTEMPT_MESSAGE_SEND_WITH_LOCATION = 'ATTEMPT_MESSAGE_SEND_WITH_LOCATION'
export const ATTEMPT_SUBMIT_ALERT = 'ATTEMPT_SUBMIT_ALERT'
export const ATTEMPT_SUBMIT_ALERT_WITH_LOCATION = 'ATTEMPT_SUBMIT_ALERT_WITH_LOCATION'
export const AUTH_FETCH_FIREBASE_TOKEN = 'AUTH_FETCH_FIREBASE_TOKEN'
export const AUTH_FETCH_FIREBASE_TOKEN_FAIL = 'AUTH_FETCH_FIREBASE_TOKEN_FAIL'
export const AUTH_FETCH_FIREBASE_TOKEN_SUCCESS = 'AUTH_FETCH_FIREBASE_TOKEN_SUCCESS'
export const AUTH_SET_KEYS = 'AUTH_SET_KEYS'
export const AUTH_SET_TOKEN = 'AUTH_SET_TOKEN'
export const AUTH_SET_TOKEN_FAIL = 'AUTH_SET_TOKEN_FAIL'
export const AUTH_VALIDATE = 'AUTH_VALIDATE'
export const AUTH_VALIDATE_SUCCESS = 'AUTH_VALIDATE_SUCCESS'
export const CARD_ACTION_SUBMIT = 'CARD_ACTION_SUBMIT'
export const CARD_DROPDOWN_ITEM_SUBMIT = 'CARD_DROPDOWN_ITEM_SUBMIT'
export const CLEAR_REDIRECT = 'CLEAR_REDIRECT'
export const CTA_SUBMIT = 'CTA_SUBMIT'
export const CTA_SUBMIT_FAIL = 'CTA_SUBMIT_FAIL'
export const ERROR_MODAL_CLOSE = 'ERROR_MODAL_CLOSE'
export const ERROR_MODAL_OPEN = 'ERROR_MODAL_OPEN'
export const FETCH_ELECTRON_LOCALE = 'FETCH_ELECTRON_LOCALE'
export const FETCH_ELECTRON_OS_USER = 'FETCH_ELECTRON_OS_USER'
export const GROW_MESSAGE_LIMIT = 'GROW_MESSAGE_LIMIT'
export const FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST = 'FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST'
export const FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST_FAIL = 'FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST_FAIL'
export const FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST_SUCCESS = 'FILE_COMPLETE_MULTIPART_UPLOAD_REQUEST_SUCCESS'
export const FILE_MODAL_CLOSE = 'FILE_MODAL_CLOSE'
export const FILE_MODAL_OPEN = 'FILE_MODAL_OPEN'
export const FILE_MULTIPART_UPLOAD_REQUEST = 'FILE_MULTIPART_UPLOAD_REQUEST'
export const FILE_MULTIPART_UPLOAD_REQUEST_FAIL = 'FILE_MULTIPART_UPLOAD_REQUEST_FAIL'
export const FILE_MULTIPART_UPLOAD_REQUEST_SUCCESS = 'FILE_MULTIPART_UPLOAD_REQUEST_SUCCESS'
export const FILE_REMOVE = 'FILE_REMOVE'
export const FILE_REMOVE_SERVER = 'FILE_REMOVE_SERVER'
export const FILE_SELECT = 'FILE_SELECT'
export const FILE_UPLOAD_S3 = 'FILE_UPLOAD_S3'
export const FILE_UPLOAD_S3_FAIL = 'FILE_UPLOAD_S3_FAIL'
export const FILE_UPLOAD_S3_SUCCESS = 'FILE_UPLOAD_S3_SUCCESS'
export const FILE_URL_REQUEST = 'FILE_URL_REQUEST'
export const FILE_URL_REQUEST_FAIL = 'FILE_URL_REQUEST_FAIL'
export const FILE_URL_REQUEST_SUCCESS = 'FILE_URL_REQUEST_SUCCESS'
export const FILES_SET = 'FILES_SET'
export const HIDE_ACTION_SHEET = 'HIDE_ACTION_SHEET'
export const LOCATION_FETCH_FAIL = 'LOCATION_FETCH_FAIL'
export const LOCATION_FETCHING = 'LOCATION_FETCHING'
export const LOCATION_PERMISSION_CHECK = 'LOCATION_PERMISSION_CHECK'
export const LOCATION_PERMISSION_STATUS_SET = 'LOCATION_PERMISSION_STATUS_SET'
export const LOCATION_RESET = 'LOCATION_RESET'
export const LOCATION_SET = 'LOCATION_SET'
export const LOCATION_UNSET = 'LOCATION_UNSET'
export const LOCATION_WATCH_POSITION = 'LOCATION_WATCH_POSITION'
export const LOCATION_WATCH_POSITION_FAIL = 'LOCATION_WATCH_POSITION_FAIL'
export const LOCATION_WATCH_POSITION_SUCCESS = 'LOCATION_WATCH_POSITION_SUCCESS'
export const MARK_MESSAGE_READ = 'MARK_MESSAGE_READ'
export const MESSAGE_IS_SENDING = 'MESSAGE_IS_SENDING'
export const MESSAGE_SEND = 'MESSAGE_SEND'
export const MESSAGE_SEND_FAIL = 'MESSAGE_SEND_FAIL'
export const MESSAGE_SEND_SUCCESS = 'MESSAGE_SEND_SUCCESS'
export const MESSAGE_SUBMIT_ATTEMPT = 'MESSAGE_SUBMIT_ATTEMPT'
export const ON_CTA_SUBMIT = 'ON_CTA_SUBMIT'
export const ON_MESSAGE_SEND = 'ON_MESSAGE_SEND'
export const ON_SUBMIT_SEARCHLIGHT = 'ON_SUBMIT_SEARCHLIGHT'
export const ON_SUBMIT_TIP = 'ON_SUBMIT_TIP'
export const PANIC_BUTTON_SUBMIT = 'PANIC_BUTTON_SUBMIT'
export const PANIC_BUTTON_SUBMIT_SUCCESS = 'PANIC_BUTTON_SUBMIT_SUCCESS'
export const PRIORITY_CONNECT_SUBMIT = 'PRIORITY_CONNECT_SUBMIT'
export const PRIORITY_CONNECT_SUBMIT_SUCCESS = 'PRIORITY_CONNECT_SUBMIT_SUCCESS'
export const SAFEWALK_ALERT_ACTION_SUBMIT = 'SAFEWALK_ALERT_ACTION_SUBMIT'
export const SAFEWALK_ALERT_ACTION_SUBMIT_FAIL = 'SAFEWALK_ALERT_ACTION_SUBMIT_FAIL'
export const SAFEWALK_ALERT_ACTION_SUBMIT_SUCCESS = 'SAFEWALK_ALERT_ACTION_SUBMIT_SUCCESS'
export const SAFEWALK_ALERT_CANCEL_TIMER_SUBMIT = 'SAFEWALK_ALERT_CANCEL_TIMER_SUBMIT'
export const SAFEWALK_ALERT_SUBMIT = 'SAFEWALK_ALERT_SUBMIT'
export const SAFEWALK_ALERT_SUBMIT_FAIL = 'SAFEWALK_ALERT_SUBMIT_FAIL'
export const SAFEWALK_ALERT_SUBMIT_SUCCESS = 'SAFEWALK_ALERT_SUBMIT_SUCCESS'
export const SAFEWALK_ALERT_SUCCESS = 'SAFEWALK_ALERT_SUCCESS'
export const SAFEWALK_ALERT_TIMELINE_ACTION_SUBMIT = 'SAFEWALK_ALERT_TIMELINE_ACTION_SUBMIT'
export const SAFEWALK_ALERT_TIMER_SUBMIT = 'SAFEWALK_ALERT_TIMER_SUBMIT'
export const SAFEWALK_ALERT_TIMER_SUBMIT_FAIL = 'SAFEWALK_ALERT_TIMER_SUBMIT_FAIL'
export const SAFEWALK_ALERT_TIMER_SUBMIT_SUCCESS = 'SAFEWALK_ALERT_TIMER_SUBMIT_SUCCESS'
export const SAFEWALK_ALERT_UPDATE_LOCATION = 'SAFEWALK_ALERT_UPDATE_LOCATION'
export const SAFEWALK_CONTACTS_SUBMIT = 'SAFEWALK_CONTACTS_SUBMIT'
export const SAFEWALK_CONTACTS_SUBMIT_FAIL = 'SAFEWALK_CONTACTS_SUBMIT_FAIL'
export const SAFEWALK_CONTACTS_SUBMIT_SUCCESS = 'SAFEWALK_CONTACTS_SUBMIT_SUCCESS'
export const SAFEWALK_LOCATION_FETCH_SUCCESS = 'SAFEWALK_LOCATION_FETCH_SUCCESS'
export const SAFEWALK_RESET = 'SAFEWALK_RESET'
export const SAFEWALK_SET_DATA = 'SAFEWALK_SET_DATA'
export const SAFEWALK_SET_TIMER_DURATION = 'SAFEWALK_SET_TIMER_DURATION'
export const SAFEWALK_SMS_SUBMIT = 'SAFEWALK_SMS_SUBMIT'
export const SAFEWALK_SMS_SUBMIT_FAIL = 'SAFEWALK_SMS_SUBMIT_FAIL'
export const SAFEWALK_SMS_SUBMIT_SUCCESS = 'SAFEWALK_SMS_SUBMIT_SUCCESS'
export const SAFEWALK_START_ALARM = 'SAFEWALK_START_ALARM'
export const SAFEWALK_UPDATE_ALARM = 'SAFEWALK_UPDATE_ALARM'
export const SAFEWALK_UPDATE_ALARM_FAIL = 'SAFEWALK_UPDATE_ALARM_FAIL'
export const SAFEWALK_UPDATE_ALARM_SUCCESS = 'SAFEWALK_UPDATE_ALARM_SUCCESS'
export const SAFEWALK_UPDATE_STATE = 'SAFEWALK_UPDATE_STATE'
export const SCROLL_TO_UNREAD = 'SCROLL_TO_UNREAD'
export const SEARCHLIGHT_CONFIRM_MODAL_CLOSE = 'SEARCHLIGHT_CONFIRM_MODAL_CLOSE'
export const SEARCHLIGHT_CONFIRM_MODAL_OPEN = 'SEARCHLIGHT_CONFIRM_MODAL_OPEN'
export const SEARCHLIGHT_SUBMIT = 'SEARCHLIGHT_SUBMIT'
export const SEARCHLIGHT_SUBMIT_FAIL = 'SEARCHLIGHT_SUBMIT_FAIL'
export const SEARCHLIGHT_SUBMIT_SUCCESS = 'SEARCHLIGHT_SUBMIT_SUCCESS'
export const SET_ACCOUNT_CONFIG = 'SET_ACCOUNT_CONFIG'
export const SET_BREADCRUMB = 'SET_BREADCRUMaB'
export const SET_CHAT_MESSAGES = 'SET_CHAT_MESSAGES'
export const SET_CHAT_REPLIES = 'SET_CHAT_REPLIES'
export const SET_CONFIRMATION_MODAL = 'SET_CONFIRMATION_MODAL'
export const SET_CURRENT_PATH = 'SET_CURRENT_PATH'
export const SET_ELECTRON = 'SET_ELECTRON'
export const SET_ENGAGEMENT_DETAIL_ID = 'SET_ENGAGEMENT_DETAIL_ID'
export const SET_ENGAGEMENTS = 'SET_ENGAGEMENTS'
export const SET_FILTERED_ENGAGEMENTS = 'SET_FILTERED_ENGAGEMENTS'
export const SET_IS_AWAITING_MESSAGE = 'SET_IS_AWAITING_MESSAGE'
export const SET_IS_READY = 'SET_IS_READY'
export const SET_LOADING = 'SET_LOADING'
export const SET_MESSAGES_TO_SEND = 'SET_MESSAGES_TO_SEND'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const SET_REDIRECT = 'SET_REDIRECT'
export const SET_REPLY_GUID = 'SET_REPLY_GUID'
export const SET_SENTRY_ERROR = 'SET_SENTRY_ERROR'
export const SET_SHOW_SCROLL_INDICATOR = 'SET_SHOW_SCROLL_INDICATOR'
export const SET_TABS = 'SET_TABS'
export const SET_TIP_DATA = 'SET_TIP_DATA'
export const SET_TIP_LOCATION_TOGGLE = 'SET_TIP_LOCATION_TOGGLE'
export const SET_UNREAD_MESSAGE_INDEX = 'SET_UNREAD_MESSAGE_INDEX'
export const SET_USER_CONFIG = 'SET_USER_CONFIG'
export const SET_WATCH_POSITION_LISTENER = 'SET_WATCH_POSITION_LISTENER'
export const SHOW_ACTION_SHEET = 'SHOW_ACTION_SHEET'
export const TIP_DATA_RESET = 'TIP_DATA_RESET'
export const TIP_MODAL_CLOSE = 'TIP_MODAL_CLOSE'
export const TIP_SET_CONFIRMATION_TEXT = 'TIP_SET_CONFIRMATION_TEXT'
export const TIP_SUBMIT = 'TIP_SUBMIT'
export const TIP_SUBMIT_ATTEMPT = 'TIP_SUBMIT_ATTEMPT'
export const TIP_SUBMIT_FAIL = 'TIP_SUBMIT_FAIL'
export const TIP_SUBMIT_SUCCESS = 'TIP_SUBMIT_SUCCESS'
export const TOGGLE_TAB_BAR = 'TOGGLE_TAB_BAR'
export const UPDATE_LOADING = 'UPDATE_LOADING'
